import React, { useState, useEffect } from 'react';
import { FlowentryCardColors } from '../Colors'
import styles from './css/week-animation.module.css';

function WeekAnimation({ animate = true, animationDuration, showCircleOnly, daysAndColors }) {
    const elements = daysAndColors ?? [
        { day: 'M', color: FlowentryCardColors.greenColorScheme.BG },
        { day: 'T', color: FlowentryCardColors.lightGreenColorScheme.BG },
        { day: 'W', color: FlowentryCardColors.lightRedColorScheme.BG },
        { day: 'T', color: FlowentryCardColors.greenColorScheme.BG },
        { day: 'F', color: FlowentryCardColors.lightGreenColorScheme.BG },
    ];
    const [activeElements, setActiveElements] = useState(animate ? Array(elements.length).fill(false)
        : Array(elements.length).fill(true));

    useEffect(() => {
        if (!animate) return;

        // Trigger elements to appear sequentially
        activeElements.forEach((_, index) => {
            setTimeout(() => {
                setActiveElements(prev => {
                    const newState = [...prev];
                    newState[index] = true;
                    return newState;
                });
            }, index * (animationDuration ?? 400)); //400ms by default
        });
    }, [animate]);

    return (
        <div className={styles.container}>
            {activeElements.map((isActive, index) => (
                <div key={index} className={styles.dayWrapper}>
                    {!showCircleOnly &&
                        <div
                            className={styles.dayLabel}
                            style={{
                                opacity: !animate || isActive ? 1 : 0,
                                transition: animate ? 'opacity 300ms ease-in' : 'none'
                            }}
                        >
                            {elements[index].day}
                        </div>
                    }
                    <div
                        className={styles.circle}
                        style={{
                            background: elements[index].color,
                            opacity: !animate || isActive ? 1 : 0,
                            transition: animate ? 'opacity 300ms ease-in' : 'none',
                            fontSize: showCircleOnly ? '0.8rem' : '1rem'
                        }}
                    >
                        {daysAndColors ? elements[index].day : index + 1}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default WeekAnimation;